<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>{{ titulo }}</h5>
                <hr>

                <DadosClientePanel ref="dadosCliente" :modo="modo" :clienteId="clienteId" :initialData="clienteData" />
                <EnderecoPanel ref="endereco" :modo="modo" :clienteId="clienteId" :initialData="enderecoData" />
                <ContaPanel ref="conta" :modo="modo" :clienteId="id" :initialData="contaData" />
                <PlanoPanel ref="plano" :modo="modo" :clienteId="id" :initialData="planoAtualData" />

                <!-- Botões de ação no modo novo -->
                <div v-if="modo === 'novo'" class="p-d-flex p-jc-end p-mt-4">
                    <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary p-mr-2" @click="voltar" />
                    <Button label="Salvar" icon="pi pi-save" @click="salvar" :loading="enviando" />
                </div>
                <div v-else class="p-d-flex p-jc-start p-mt-4">
                    <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" @click="voltar" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import { exibirMensagem } from '@/global';
import DadosClientePanel from './DadosClientePanel.vue';
import EnderecoPanel from './EnderecoPanel.vue';
import ContaPanel from './ContaPanel.vue';
import PlanoPanel from './PlanoPanel.vue';

export default {
    components: { DadosClientePanel, EnderecoPanel, ContaPanel, PlanoPanel },
    props: {
        id: {
            type: [String, Number],
            default: null
        },
		clienteId: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            enviando: false,
            clienteData: null,
            enderecoData: null,
            contaData: null,
            planoAtualData: null
        };
    },
    computed: {
        modo() {
            return this.id ? 'edicao' : 'novo';
        },
        titulo() {
            return this.id ? 'Editar Cliente' : 'Novo Cliente';
        }
    },
    methods: {
        salvar() {
            const dadosValido = this.$refs.dadosCliente.validar();
            const contaValido = this.$refs.conta.validar();
            const planoValido = this.$refs.plano.validar();

            if (!dadosValido || !contaValido || !planoValido) {
                this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Preencha todos os campos obrigatórios.', life: 3000 });
                return;
            }

            this.enviando = true;
            const payload = {
                conta: this.$refs.conta.getData(),
                cliente: {
                    ...this.$refs.dadosCliente.getData(),
                    endereco: this.$refs.endereco.getData()
                },
                plano: this.$refs.plano.getData()
            };

            this.clienteService.salvarConta(payload)
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo com sucesso.', life: 3000 });
                    setTimeout(() => {
						this.voltar();
					}, 2000);
                })
                .catch(erro => { exibirMensagem(this, erro); })
                .finally(() => { this.enviando = false; });
        },
        buscarCliente() {
            this.clienteService.buscarConta(this.id)
                .then(resp => {
                    const { endereco } = resp.data.cliente;
                    this.clienteData = resp.data.cliente;
                    this.enderecoData = endereco;
                    this.contaData = resp.data.conta;
                    this.planoAtualData = resp.data.plano;
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        voltar() {
            this.$router.push('/cadastro/clientes/ikacesso');
        }
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
    },
    mounted() {
        if (this.id) {
            this.buscarCliente();
        }
    }
};
</script>

<style>
</style>